module.exports = __webpack_public_path__ + "static/media/3.bc7682ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobileOmBoarding/3.png
// module id = 932
// module chunks = 21